var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack213({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,9.36l1.68.54A3.83,3.83,0,0,1,10.43,12a3.7,3.7,0,0,1-2.28.68A3.68,3.68,0,0,1,5.34,11.5a4.46,4.46,0,0,1-1.1-3.2A4.68,4.68,0,0,1,5.34,5,3.8,3.8,0,0,1,8.25,3.79a3.59,3.59,0,0,1,2.57.93,3.29,3.29,0,0,1,.87,1.58L10,6.71A1.77,1.77,0,0,0,8.17,5.27,2,2,0,0,0,6.62,6,3.35,3.35,0,0,0,6,8.17a3.59,3.59,0,0,0,.59,2.32,1.88,1.88,0,0,0,1.52.7,1.75,1.75,0,0,0,1.19-.44A2.65,2.65,0,0,0,10,9.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack213);
export default __webpack_public_path__ + "static/media/Symbolpack_2_13.65e545c228642f3d4472811afcacfdfe.svg";
export { ForwardRef as ReactComponent };